/**
 *
 * @param {Object} obj
 * @param {Array} rules
 */
import { Message, MessageBox } from 'element-ui'
import { JUMP_URL } from '@/config/constant'
let rules = {
  // 检测是否实名认证 1表示已实名
  checkAuth (auth) {
    if (auth !== '1') {
      MessageBox.alert('<div class="fb f16">请先进行实名认证</div>',
        '', {
          type: 'warning',
          confirmButtonText: '立即前往撮合商城认证',
          dangerouslyUseHTMLString: true,
          center: true
        }).then(() => {
        window.open(JUMP_URL + 'certification', '_blank')
      })
    }
    return auth === '1'
  },
  checkEmptyRules (obj, rules) {
    let isEmpty = false
    for (let item of rules) {
      if ((!obj[item.name] && obj[item.name] !== 0) || (obj[item.name] instanceof Array && !obj[item.name].length)) {
        Message.warning(item.message)
        isEmpty = true
        break
      }
    }
    return isEmpty
  },
  checkInputFormat (reg, value, message) {
    if (!reg.test(value)) {
      Message.error(message)
      return false
    }
    return true
  },
  checkByValidator (func, value, message) {
    if (!func(value)) {
      Message.error(message)
      return false
    }
    return true
  },
  // 手机号码
  phone (value) {
    let isMobile = /^((1[3-9]{1}[0-9]{1})+\d{8})$/ // 增加了16+ 和 19+ 网段
    if (!(isMobile.test(value))) {
      Message.error('请输入正确格式的11位手机号')
    }
    return (isMobile.test(value))
  },
  // 密码二次确认
  confirmPassword (psw, confirmPsw) {
    if (!(confirmPsw === psw)) {
      Message.error('两次密码输入不一致')
    }
    return (confirmPsw === psw)
  },
  // 密码校验
  password (psw) {
    let isPsw = /(?=.*\d)(?=.*[a-zA-Z]).{6,16}$/
    if (!(isPsw.test(psw))) {
      Message.error('请输入6-16位由数字和字母组成的新密码')
    }
    return (isPsw.test(psw))
  },
  // 限制文件类型--比如：图片类型必须是.gif,jpeg,jpg,png,bmp中的一种 正则：'\\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$'
  checkFileType (obj, regRule, value, hint) {
    let reg = new RegExp(regRule, 'ig')
    if (!reg.test(value)) {
      obj.$alert(hint, '警告', {
        confirmButtonText: '确定',
        type: 'warning'
      })
      return false
    }
    return true
  },
}

export default rules
